import API from "./Api";

export default {
    async getAllOwn() {

        return API.get("/company/getallown", "MOODLE_SESSION_JSON");
    },
    async getFirst() {

        return API.get("/company/getfirst", "MOODLE_SESSION_JSON");
    },
    async create(form) {
        return API.post(`/company/create/`, form, "MOODLE_SESSION_JSON");
    },
    async update(form) {
        const customerId = form.id;
        const instance_id = form.instance_id;
        return API.post(`/company/update/${customerId}/${instance_id}`, form, "MOODLE_SESSION_JSON");
    },
}